import styled from '@emotion/styled'
import styles, { typo } from '@mathflat/common/style'

const {
  colors: { gray },
} = styles
const ConfirmModalStyled = styled.div`
  .confirm-modal-container {
    width: 494px;
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .confirm-modal-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 8px 0;

    > img {
      width: 36px;
      height: 36px;
      margin-bottom: 10px; /* 예외 */
    }

    > h2 {
      ${typo.heading05};
      font-weight: 700;
      color: ${gray.$900};
    }
  }
  .confirm-modal-body {
    text-align: center;
  }
  .confirm-modal-footer {
    display: flex;
    justify-content: center;

    > button {
      width: max-content;
      min-width: 100px;
      padding: 0 12px;

      & + button {
        margin-left: 8px;
      }
    }
  }
  .confirm-modal-option {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    transform: translateY(100%);
    z-index: 10000;
    ${typo.body01};

    .option {
      padding-top: 10px;
      z-index: 10000;
      color: #fff;
      ${typo.body02};
    }

    .right-bottom-close-text-button {
      padding-top: 10px;
      z-index: 10000;
      color: #fff;
      ${typo.body02};
    }
  }
`

export default ConfirmModalStyled
